import React from "react";
import { useNavigate } from "react-router-dom";

const useRedirect = () => {
    const navigate = useNavigate();

    return (url, external) => {
        if (external) {
            document.location.href = url;
        } else {
            navigate(url, { replace: true });
        }
    };
};

export default useRedirect;
